<template>
  <div class="space-y-12">
    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Subject</h5>
      <h1
        v-if="editedAttributes.indexOf('title') === -1"
        v-text="title || 'Task title'"
        class="text-xl font-medium px-3 py-1 bg-gray-200 rounded"
        @click="editAttribute('title')"
      />
      <input
        v-else
        v-select
        type="text"
        v-model="wip.title"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full"
        @blur="commitAttributeChanges('title')"
        @keydown.enter="commitAttributeChanges('title')"
        @keydown.esc="revertAttributeChanges('title')"
      />
    </div>

    <div>
      <h5 class="text-sm font-medium tracking-wide text-gray-700 mb-2">Description</h5>
      <div
        v-if="editedAttributes.indexOf('content') === -1"
        v-text="content || 'Type a description'"
        class="text-sm whitespace-pre-line px-3 py-1 bg-gray-200 rounded font-normal font-sans break-words"
        @click="editAttribute('content')"
      />
      <textarea
        v-else
        v-select
        v-model="wip.content"
        rows="10"
        class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full resize-none"
        @blur="commitAttributeChanges('content')"
        @keydown.ctrl.enter="commitAttributeChanges('content')"
        @keydown.esc="revertAttributeChanges('content')"
      />
    </div>
  </div>
</template>

<script>
import { kebabCase } from 'lodash-es';

export default {
  name: 'Attributes',

  props: {
    editable: Boolean,
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editedAttribute: null,
      wip: {},
    };
  },

  computed: {
    editedAttributes() {
      return Object.keys(this.wip);
    },
  },

  methods: {
    editAttribute(attribute) {
      if (!this.editable) {
        return;
      }

      this.wip = {
        ...this.wip,
        [attribute]: this[attribute],
      };
    },
    editAttributes(attributes) {
      attributes.forEach((attribute) => this.editAttribute(attribute));
    },
    commitAttributeChanges(attribute) {
      const { [attribute]: changedAttribute, ...remainingChangedAttributes } = this.wip;

      if (changedAttribute === undefined) {
        return;
      }

      this.$emit(`update:${kebabCase(attribute)}`, changedAttribute);

      this.wip = { ...remainingChangedAttributes };
    },
    commitAttributesChanges(attributes) {
      attributes.forEach((attribute) => this.commitAttributeChanges(attribute));
    },
    revertAttributeChanges(attribute) {
      const { [attribute]: changedAttribute, ...remainingChangedAttributes } = this.wip;

      if (changedAttribute === undefined) {
        return;
      }

      this.wip = { ...remainingChangedAttributes };
    },
    revertAttributesChanges(attributes) {
      attributes.forEach((attribute) => this.revertAttributeChanges(attribute));
    },
  },
};
</script>
